import React from "react";
import OurServices from "../../Components/Service/Service";
import Services from "../../Components/Services/Services";
import Ambassador from "../../Components/Ambassador/Ambassador";
import VP3 from "../../Components/videoPlayer2/vp3";

const Service = () => {
  return (
    <div style={{ overflow: "hidden" }}>
      <OurServices />
      <Services />
      <VP3 />
      <Ambassador />
    </div>
  );
};

export default Service;
